import { useLoading } from "context/LoadingContext";
import { ToastContext } from "context/ToastContext";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateManyInstitutionalRulesetsMutation } from "store/queries/institutionalRuleset";

import {
  IInstitutionalRulesetFormData,
  INITIAL_INSTITUTIONAL_FORM_DATA,
  InstitutionalRulesetForm,
} from "./components/InstitutionalRulesetForm";

export function CreateInstitutionalRulesetPage() {
  useDocumentTitle("Create Institutional Ruleset");
  const navigate = useNavigate();
  const { setIsLoading } = useLoading();
  const { current: toastElement } = useContext(ToastContext);
  const [createManyMutation, { isLoading }] =
    useCreateManyInstitutionalRulesetsMutation();
  const [formData, setFormData] = useState<IInstitutionalRulesetFormData>(
    INITIAL_INSTITUTIONAL_FORM_DATA
  );

  const handleSubmit = async () => {
    if (!formData.providerIds.length || !formData.payerIds.length) return;
    setIsLoading(true);
    try {
      const created = await createManyMutation({
        providerIds: formData.providerIds,
        payerIds: formData.payerIds,
        primarySelectionMethod: formData.primarySelectionMethod,
      }).unwrap();
      const count = created.data?.length ?? 0;
      toastElement?.show({
        severity: "success",
        summary: "Created!",
        detail: `${count} institutional ruleset${
          count === 1 ? "" : "s"
        } created successfully.`,
      });
      navigate("/payer-rules");
    } catch (error: any) {
      toastElement?.show({
        severity: "error",
        summary: "Error",
        detail:
          error?.data?.message || "Failed to create institutional rulesets",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <InstitutionalRulesetForm
      title="Create Institutional Rulesets"
      submitLabel="Create Rulesets"
      formData={formData}
      onChange={setFormData}
      onSubmit={handleSubmit}
      isSubmitting={isLoading}
      multiScope
    />
  );
}
